import { render, staticRenderFns } from "./displayAdvertising.vue?vue&type=template&id=c8f9a946&scoped=true"
import script from "./displayAdvertising.vue?vue&type=script&lang=js"
export * from "./displayAdvertising.vue?vue&type=script&lang=js"
import style0 from "./displayAdvertising.vue?vue&type=style&index=0&id=c8f9a946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f9a946",
  null
  
)

export default component.exports